import { ColumnType, MatchedOptions, MatchedSelectColumn, MatchedSelectOptionsColumn, MatchedColumn } from '../Steps/MatchColumns'


export const setSubColumn = <T>(
  oldColumn: MatchedSelectColumn<T> | MatchedSelectOptionsColumn<T> | MatchedColumn<T>,
  entry: string,
  value: string,
  isFuelType: boolean,
  onlyOneOption?: boolean
): MatchedSelectColumn<T> | MatchedSelectOptionsColumn<T> | MatchedColumn<T> => {
  const options = oldColumn.type === ColumnType.matchedSelect ? (oldColumn as MatchedSelectColumn<T>).matchedOptions.map(option => (option.entry === entry ? { ...option, value, isFuelType } : option)) :
    oldColumn.type === ColumnType.matchedSelectOptions ? (oldColumn as MatchedSelectOptionsColumn<T>).matchedOptions.map(option => (option.entry === entry ? { ...option, value, isFuelType } : option)) :
      oldColumn.type === ColumnType.matched && oldColumn.matchedOptions?.length ? (oldColumn as MatchedColumn<T>).matchedOptions?.map(option => (option.entry === entry ? { ...option, value, isFuelType } : option))
        : [];

  const allMathced = !onlyOneOption  ? options?.every(({ value }) => !!value) : options?.length && !!options[0].value;
  if (allMathced) {
    return { ...oldColumn, matchedOptions: options as MatchedOptions<T>[], type: ColumnType.matchedSelectOptions }
  } else {
    return { ...oldColumn, matchedOptions: options as MatchedOptions<T>[], type: ColumnType.matchedSelect }
  }
}
